"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDetailApi = getDetailApi;
exports.homeApi = homeApi;
exports.homePinApi = homePinApi;
exports.saveOrUpdateApi = saveOrUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 保存装修页
 */
function saveOrUpdateApi(data) {
  return (0, _request.default)({
    url: '/admin/company-design/saveOrUpdate',
    method: 'POST',
    data: data
  });
}

/**
 *装修模拟首页商品
 */
function homeApi(params) {
  // return request({
  //     url: '/admin/store/product/index/home',
  //     method: 'GET',
  //     params,
  // });
  return requestMapi({
    url: '/mapi/product/store/product/index/home',
    method: 'GET',
    params: params
  });
}

/**
 *装修模拟首页商品-拼团
 */
function homePinApi(params) {
  return (0, _request.default)({
    url: '/admin/store/combination/index',
    method: 'GET',
    params: params
  });
}

/**
 * 详情
 */
function getDetailApi(params) {
  return (0, _request.default)({
    url: '/admin/company-design/getDetail',
    method: 'GET',
    params: params
  });
}